export enum NotificationTypesEnum {
  // Receiving a file
  ReceivedFile = 'receivedFile',
  ReceivedLicense = 'receivedLicense',

  // Transferring
  TransferRequest = 'transferRequest',
  TransferAccepted = 'transferAccepted',

  // General
  FileUploadFailed = 'fileUploadFailed',
  AccountPaymentFailed = 'accountPaymentFailed',
  TrialExpiresSoon = 'trialExpiresSoon',

  // Licensing
  LicenseRequest = 'licenseRequest',
  LicenseRequestPaid = 'licenseRequestPaid',
  LicenseeWillExpire = 'licenseeWillExpire',
  LicenseeExpired = 'licenseeExpired',
  LicenserWillExpire = 'licenserWillExpire',
  LicenserExpired = 'licenserExpired',

  // Buying / Selling
  PaymentRequest = 'paymentRequest',
  PaymentPaid = 'paymentPaid',

  // Invoices
  InvoicePaid = 'invoicePaid',
  InvoiceOverdue = 'invoiceOverdue',
}

export enum TransactionSuccessTypes {
  SellRequest = 'SellRequest',
  TransferRequest = 'TransferRequest',
  AcceptSale = 'AcceptSale',
  AcceptTransfer = 'AcceptTransfer',
  LicenseRequest = 'LicenseRequest',
  AcceptLicense = 'AcceptLicense',
  Cancel = 'Cancel',
}

export enum SelectPlanType {
  Register = 'register',
  Upgrade = 'upgrade',
  Change = 'change-plans',
  Onboarding = 'onboarding',
}

export enum TableTypes {
  Explorer = 'Explorer',
  Archive = 'Archive',
  SearchFiles = 'SearchFiles',
}
